<sh-volume-anomaly-widgets
  [anomalyWidgetData]="anomalyWidgetData$"
></sh-volume-anomaly-widgets>
<sh-volume-anomaly-graph
  class="chart-container"
  [anomalyGraphData]="anomalyGraphData$"
></sh-volume-anomaly-graph>
